import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { DisbursalReversalObj } from "../../utils/types";

const initialState: DisbursalReversalObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAllDisbursalReversalData = createAsyncThunk(
  "getAllDisbursalReversal",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const disbursalReversalSlice = createSlice({
  name: "disbursalReversal",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllDisbursalReversalData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllDisbursalReversalData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAllDisbursalReversalData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default disbursalReversalSlice.reducer;
